require('./../css/layout.less');

import 'jquery';
import 'bootstrap';

window.$ = window.jQuery = $;
window.axios = require('axios');

import './modules/_bigslide.js';
import './modules/_scroll.js';
import './modules/_equalheight.js';
import './modules/_navigation.js';
import './modules/_products.js';
import './modules/_fancybox.js';
import './modules/_filter_change.js';
import './modules/_cart.js';
if ($('.owl-carousel').length) require('./modules/_owlcarousel.js');

var AOS = require('aos');
AOS.init({
  duration: 600,
  once: true
});

window.isNumber = isNumber;

function isNumber(evt) {
    evt = (evt) ? evt : window.event;
    var charcode = (evt.which) ? evt.which : evt.keyCode;
    if ((charcode > 31 && charcode < 48) || charcode > 57) {
        return false;
    }
    return true;
}



// WEBPACK FOOTER //
// ./js/script.js